export default __webpack_public_path__ + "static/media/streaming.e94c58db.gif";